exports = module.exports = require("../../../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".DS__DropListMobile__list {\n  max-height: 320px;\n}\n\n.DS__DropListMobile__search {\n  padding-top: 8px;\n  padding-bottom: 8px;\n  border-bottom: 1px solid #dde3ed;\n}\n\n.DS__DropListMobile__subtitle-block {\n  padding: 24px 12px 0 12px;\n}\n\n.DS__DropListMobile__subtitle-block .DS__DropListMobile__subtitle {\n  padding-bottom: 8px;\n  text-transform: uppercase;\n}\n\n.DS__DropListMobile__theme_b2c .DS__DropListMobile__icon_check {\n  color: #97ba1e;\n}\n\n.DS__DropListMobile__theme_b2b .DS__DropListMobile__icon_check {\n  color: #00a4ba;\n}\n", ""]);

// exports
exports.locals = {
	"list": "DS__DropListMobile__list",
	"search": "DS__DropListMobile__search",
	"subtitle-block": "DS__DropListMobile__subtitle-block",
	"subtitle": "DS__DropListMobile__subtitle",
	"theme_b2c": "DS__DropListMobile__theme_b2c",
	"icon_check": "DS__DropListMobile__icon_check",
	"theme_b2b": "DS__DropListMobile__theme_b2b"
};